// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"20":"4d5195f89201a6622dc8","54":"dc909ed27917dbe2bb96","754":"92d20fe6072c545fc410","791":"32e63f457fd98405c364","858":"dc909ed27917dbe2bb96","981":"dc909ed27917dbe2bb96"}[chunkId] + ".css";
};